module.exports = ".map {\r\n\tposition: relative;\r\n}\r\n\r\n.room{\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n}\r\n\r\n.room-name{\r\n  font-family: KimberleyRegular;\r\n  font-size: 1.4vw;\r\n  color: hsl(0, 0%, 8%);\r\n}\r\n\r\n.room:hover, .room:hover * {\r\n  color: hsl(217, 71%, 53%);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/map/map.css
// module id = ./src/app/map/map.css
// module chunks = main